<template>
  <span class="Timer">{{text}}</span>
</template>
<script>
export default {
  name: "Timer",
  props: {
    time: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    currentTime: 0,
    interval: null
  }),
  mounted() {
    if (this.time > 0) {
      this.start();
    }
  },
  computed: {
    text() {
      return new Date(this.currentTime * 1000).toISOString().substr(14, 5);
    }
  },
  watch: {
    time(val) {
      if (val > 0) {
        this.start();
      }
    }
  },
  methods: {
    start() {
      const _this = this;
      this.currentTime = this.time;
      this.interval = setInterval(() => {
        _this.tick();
      }, 1000);
    },
    tick() {
      if (this.currentTime > 0) {
        this.currentTime -= 1;
        this.$emit("tick", this.currentTime);
      } else {
        this.stop();
      }
    },
    stop() {
      this.$emit("finish");
      clearInterval(this.interval);
    },
    reset() {
      this.$emit("reset");
      clearTimeout(this.interval);
      const _this = this;
      this.currentTime = this.time;
      this.interval = setInterval(() => {
        _this.tick();
      }, 1000);
    }
  }
};
</script>